var CurrentUser = require("lib/account/CurrentUser");
import fetch from 'cross-fetch';

var AutograderFeedback = {

	preProcess: function(submitAnswerData) {
		var preProcessing= {};
		//ALPHA RATIO - Amount of alpha characters versus 
		var alphaChars = submitAnswerData["answer"].match(/[a-zA-Z]/g);
		if (alphaChars != null) {
			var alphaRatio = alphaChars.length / submitAnswerData["answer"].replace(/\s/g,"").length;;
		} else {
			var alphaRatio = 0;			
		}
	    preProcessing["alpha_ratio"] = alphaRatio;
		
		return preProcessing;
	}, 

	getHost() {
		if ($wr.isStaging() || !$wr.checkCustomEnv("local-alexandria")) {
			return "https://alex4.whooosreading.org";
		} else if ($wr.isProduction() || !$wr.checkCustomEnv("local-alexandria")) {
			return "https://alex5.whooosreading.org";
		} else {
			return "https://alex5-staging.whooosreading.org";
			// return "http://localhost:3007";		
		}
			
	},

	getFitbApiHost() {
		if ($wr.isStaging()) {
			return "https://yoo2zmt9qf.execute-api.us-east-1.amazonaws.com/Staging";
		} else if ($wr.isProduction()) {
			return "https://grading.whooosreading.org";
		} else {
			return "https://yoo2zmt9qf.execute-api.us-east-1.amazonaws.com/Staging";
		}		
	},

	requestOps(bodyData) {
		return {
			method: "POST",
			mode: "cors", // no-cors, cors, *same-origin
			cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
			credentials: "same-origin", // include, *same-origin, omit
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
			redirect: "follow", // manual, *follow, error
			referrer: "no-referrer", // no-referrer, *client
			body: JSON.stringify(bodyData),
		}
	},

	fetch: function(answerData, callback) {		
		if (answerData.quiz) {
			var quiz = answerData.quiz;
		} else {
			var quiz = false;
		} 
		var currentUserData = CurrentUser.get();

		var gradeLevel = currentUserData.prefs.academic_level;
		var gradeLevel = answerData.gradeLevel ? answerData.gradeLevel : currentUserData.prefs.academic_level;
		var studentID = currentUserData.id;
		var studentFirstName = currentUserData.first_name;

		if (answerData.sentenceStarterText) {
			var fullAnswerText = answerData.sentenceStarterText + " " + answerData.answer;
		} else {
			var fullAnswerText = answerData.answer;
		}

		var submitAnswerData = {
			answer: fullAnswerText.trim(), question_text: answerData.questionText,
			answer_parts: answerData.answerParts, starters: answerData.starters,
			question_key: answerData.questionKey,
			grade: gradeLevel, student_id: studentID,
			quiz: quiz, paste_detected: answerData.pasteDetected, duration: answerData.duration
		}

		if (answerData.forward) {
			submitAnswerData["forward"] = answerData.forward
		}
		
		if (answerData.text) {
			submitAnswerData.text_id = answerData.text.text_id;
		}

		submitAnswerData["pre_processing"] = AutograderFeedback.preProcess(submitAnswerData);

		// var autograderPath = answerData.gradeDemo ? this.getHost() + "/api/v5/grade_demo" : this.getHost() + "/api/v5/grade?which=all"; // UNCOMMENT POST MIGRATION
		var autograderPath = answerData.gradeDemo ? this.getHost() + "/api/v4/grade_demo" : this.getHost() + "/api/v4/grade?which=all";
		var request = this.requestOps(submitAnswerData);

		fetch(autograderPath, request).then(res => {
		    if (res.status >= 400) {
		      throw new Error("Bad response from server");
		    }
		    return res.json();
		  }).then(response => {
		// $wr.postJSON(autograderPath, submitAnswerData, function(response) {
			// var autograderData = response.content;
			var autograderData = response.content
			// var newContext = AutograderFeedback.updateContext(autograderContext, response.evaluation);

			var feedback = autograderData.assisting;

			if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {
				var feedbackSubs = {
					firstName: CurrentUser.get().first_name,
					textVariety: answerData.text.text_variety,
					bookTitle: answerData.text.title
				}

				var autograderData = _.extend({}, autograderData, {
					feedback_subs: feedbackSubs
				})

				callback({ autograderData });

			} else {
				callback({ noFeedback: true, autograderData });
			}

		}, function() {
			console.error("Failed to get immediate feedback. Falling back to normal submit.");
			callback({ noFeedback: true, autograderData: undefined });

		}.bind(this));
	},


	fetchFuzzyMatch: function(answerData, callback) {	

		answerData["grade"] = CurrentUser.get().prefs.academic_level;
		// var matchPath = this.getFitbApiHost() + "/api/v1.0/fuzzy_match"; // UNCOMMENT POST MIGRATION
		var matchPath = this.getHost() + "/api/v4/fuzzy_match";
		var request = this.requestOps(answerData)

		fetch(matchPath, request).then(res => {
			if (res.status >= 400) {
				throw new Error("Bad response from server");
			}
			return res.json();
		}).then(response => {
			callback({ noFeedback: true, autograderData: response.content });

		}, () => {
			console.error("Failed to get immediate matching. Falling back to normal submit.");
			callback({ noFeedback: true, autograderData: undefined });

		});
	},

	fetchQuestionBuilder: function(answerData, callback) {		
		
		var currentUserData = CurrentUser.get();

		var gradeLevel = currentUserData.prefs.academic_level;
		
		var fullAnswerText = answerData.answer;

		var submitAnswerData = {
			answer: fullAnswerText, question_text: "What is your favorite character?",
			grade: gradeLevel
		}

		if (answerData.text) {
			submitAnswerData.text_id = answerData.text.text_id;
		}

		submitAnswerData.question_builder = true
		// var autograderPath = this.getHost() + "/api/v5/grade?which=all"; // UNCOMMENT POST MIGRATION
		var autograderPath = this.getHost() + "/api/v4/grade_question_builder?which=all";
		var request = this.requestOps(submitAnswerData);

		fetch(autograderPath, request).then(res => {
		    if (res.status >= 400) {
		      throw new Error("Bad response from server");
		    }
		    return res.json();
		}).then(response => {
			
			var autograderData = response.content
			
			var feedback = autograderData.assisting;

			if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {
				var feedbackSubs = {
					firstName: CurrentUser.get().first_name,
					textVariety: answerData.text.text_variety,
					bookTitle: answerData.text.title
				}

				var autograderData = _.extend({}, autograderData, {
					feedback_subs: feedbackSubs
				})

				callback({ autograderData });

			} else {
				callback({ noFeedback: true, autograderData });
			}

		}, function() {
			console.error("Failed to get immediate feedback. Falling back to normal submit.");
			callback({ noFeedback: true, autograderData: undefined });

		}.bind(this));
	},

}

module.exports = AutograderFeedback;



// WEBPACK FOOTER //
// ./modules/lib/web/AutograderFeedback.js